/**
 * 请求类型
 */
enum CallType {
    POST = 'post',
    PUT = 'put',
    GET = 'get',
    UPDATE = 'update',
    DELETE = 'delete'
}

export default CallType;


// WEBPACK FOOTER //
// ./src/node_modules/kts-scaffold-framework/utils/ajax/CallType/index.ts